import { toast } from "sonner";

export type ErrorResponse = {
  status?: number;
  responseException?: {
    exceptionMessage:
      | {
          errors: Record<string, string[]>;
        }
      | string;
  };
};

export function handleError(err: unknown) {
  const errorResponse = err as ErrorResponse;

  const exceptionMessage = errorResponse.responseException?.exceptionMessage;

  if (
    typeof exceptionMessage === "object" &&
    exceptionMessage !== null &&
    "errors" in exceptionMessage
  ) {
    const errors = exceptionMessage.errors;
    const firstErrorKey = Object.keys(errors)[0];
    const firstErrorMessage = errors[firstErrorKey]?.[0];
    if (firstErrorMessage) {
      toast.error(firstErrorMessage);
    } else {
      toast.error("An unknown error occurred");
    }
  } else if (typeof exceptionMessage === "string") {
    toast.error(exceptionMessage);
  } else {
    toast.error("An unknown error occurred");
  }
}
